/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import axios from "axios";
import Footer from "../components/Footer";

const SchemesPage = () => {
  const [schemes, setSchemes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const API_SCHEMES = process.env.REACT_APP_API_BASE_URL + "/UIschemes";
  const API_MEDIA = process.env.REACT_APP_API_BASE_URL + "/UImedia";

  // Fetch schemes from API
  const fetchSchemes = async () => {
    try {
      setLoading(true);
      const res = await axios.get(API_SCHEMES);
      let schemesData = res.data.results || res.data.data || res.data || [];

      // If schemesData is not an array, convert it to array
      if (!Array.isArray(schemesData)) {
        schemesData = [schemesData];
      }

      // Load images for each scheme
      const schemesWithImages = await Promise.all(
        schemesData.map(async (scheme) => {
          if (scheme.image?.id) {
            try {
              const imgRes = await axios.get(`${API_MEDIA}/${scheme.image.id}/download`, {
                responseType: "blob",
              });
              scheme.imageUrl = URL.createObjectURL(imgRes.data);
            } catch (err) {
              console.error("Error loading image for", scheme.title, err);
              scheme.imageUrl = "https://via.placeholder.com/400x200.png?text=No+Image";
            }
          } else {
            scheme.imageUrl = "https://via.placeholder.com/400x200.png?text=No+Image";
          }
          return scheme;
        })
      );

      // Filter only active schemes
      const activeSchemes = schemesWithImages.filter(scheme => scheme.isActive !== false);

      setSchemes(activeSchemes);
    } catch (err) {
      console.error("Error fetching schemes:", err);
      setError("Failed to load schemes. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSchemes();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-700 text-white flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-yellow-500 mx-auto mb-4"></div>
          <p className="text-lg">Loading government schemes...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-700 text-white flex items-center justify-center">
        <div className="text-center">
          <div className="text-red-400 text-6xl mb-4">⚠️</div>
          <h2 className="text-2xl font-bold mb-2">Oops! Something went wrong</h2>
          <p className="text-gray-300 mb-4">{error}</p>
          <button
            onClick={fetchSchemes}
            className="bg-yellow-600 hover:bg-yellow-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors duration-300"
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="min-h-screen bg-gray-700 text-white p-10">
        <div className="text-center py-6 mb-10 animate-fade-in">
          <h1 className="text-5xl font-extrabold tracking-wide">Government Schemes for MSMEs & Startups</h1>
          <div className="mt-4 text-yellow-400">
            {schemes.length} {schemes.length === 1 ? 'scheme' : 'schemes'} available
          </div>
        </div>

        {schemes.length === 0 ? (
          <div className="flex items-center justify-center py-16">
            <div className="text-center">
              <div className="text-6xl mb-4">📋</div>
              <h2 className="text-2xl font-bold mb-2">No Schemes Available</h2>
              <p className="text-gray-300">Check back later for government schemes and initiatives.</p>
            </div>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {schemes.map((scheme, index) => (
              <div
                key={scheme.id || scheme._id}
                className="bg-black text-white p-6 rounded-2xl shadow-lg hover:shadow-2xl transition transform hover:scale-105 flex flex-col items-center text-center animate-slide-up"
              >
                <img
                  src={scheme.imageUrl}
                  alt={scheme.title}
                  className="w-full h-40 object-cover rounded-lg shadow-md hover:rotate-2 transition-transform"
                  onError={(e) => (e.target.src = "https://via.placeholder.com/300x200?text=Image+Not+Found")}
                />
                <h2 className="text-2xl font-bold mt-4 mb-2 text-yellow-600 hover:text-purple-600 transition-colors">
                  {scheme.title}
                </h2>
                <p className="text-yellow-300 mb-4 leading-relaxed">
                  {scheme.description || 'Click "Learn More" to view scheme details.'}
                </p>
                {scheme.userId?.name && (
                  <p className="text-sm text-gray-400 mb-2">By {scheme.userId.name}</p>
                )}
                <a
                  href={scheme.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-blue-600 text-white py-2 px-6 rounded-lg font-semibold hover:bg-purple-600 transition-transform hover:scale-105 shadow-md"
                >
                  Learn More →
                </a>
              </div>
            ))}
          </div>
        )}
      </div>
      <Footer/>
    </div>
  );
};

export default SchemesPage;




//old code for reference



// import React from "react";
// import Footer from "../components/Footer";

// const schemes = [
//   {
//     title: "Pradhan Mantri Mudra Yojana (PMMY)",
//     image: "https://res.cloudinary.com/dnmlijyox/image/upload/v1758179801/schemes-imgs/img1.webp",
//     description: "Provides loans up to ₹10 lakh to micro and small enterprises without collateral.",
//     link: "https://www.mudra.org.in/"
//   },
//   {
//     title: "Stand-Up India Scheme",
//   image: "https://res.cloudinary.com/dnmlijyox/image/upload/schemes-imgs/img2.webp",
//     description: "Aims to support SC/ST and women entrepreneurs with bank loans from ₹10 lakh to ₹1 crore.",
//     link: "https://www.standupmitra.in/"
//   },
//   {
//     title: "Startup India Initiative",
//   image: "https://res.cloudinary.com/dnmlijyox/image/upload/schemes-imgs/img3.webp",
//     description: "Provides tax exemptions, funding support, and ease of doing business for startups.",
//     link: "https://www.startupindia.gov.in/"
//   },
//   {
//     title: "Credit Guarantee Fund Scheme (CGTMSE)",
//   image: "https://res.cloudinary.com/dnmlijyox/image/upload/schemes-imgs/img4.webp",
//     description: "Offers credit guarantee to MSMEs for collateral-free loans up to ₹2 crore.",
//     link: "https://www.cgtmse.in/"
//   },
//   {
//     title: "National Small Industries Corporation (NSIC) Subsidy",
//   image: "https://res.cloudinary.com/dnmlijyox/image/upload/schemes-imgs/img5.webp",
//     description: "Provides marketing support, credit facilitation, and technology assistance to MSMEs.",
//     link: "https://www.nsic.co.in/"
//   },
//   {
//     title: "Credit Linked Capital Subsidy Scheme (CLCSS)",
//   image: "https://res.cloudinary.com/dnmlijyox/image/upload/schemes-imgs/img6.webp",
//     description: "Offers 15% capital subsidy for MSMEs upgrading technology in manufacturing.",
//     link: "https://msme.gov.in/"
//   },
//   {
//     title: "Prime Minister's Employment Generation Programme (PMEGP)",
//   image: "https://res.cloudinary.com/dnmlijyox/image/upload/schemes-imgs/img7.webp",
//     description: "Encourages self-employment by providing subsidies on project costs for new businesses.",
//     link: "https://kviconline.gov.in/pmegpeportal/pmegphome/index.jsp"
//   },
//   {
//     title: "ZED Certification Scheme",
//   image: "https://res.cloudinary.com/dnmlijyox/image/upload/schemes-imgs/img8.webp",
//     description: "Promotes quality manufacturing in MSMEs by providing financial assistance for certification.",
//     link: "https://zed.msme.gov.in/"
//   },
//   {
//     title: "Women Entrepreneurship Platform (WEP)",
//   image: "https://res.cloudinary.com/dnmlijyox/image/upload/schemes-imgs/img9.webp",
//     description: "Encourages women-led businesses by offering mentoring, funding, and networking opportunities.",
//     link: "https://wep.gov.in/"
//   },
//   {
//     title: "Technology Upgradation Fund Scheme (TUFS)",
//   image: "https://res.cloudinary.com/dnmlijyox/image/upload/schemes-imgs/img10.webp",
//     description: "Supports textile industries in upgrading technology with financial assistance.",
//     link: "https://www.txcindia.gov.in/"
//   }
// ];

// const SchemesPage = () => {
//   return (
//     <div>
//     <div className="min-h-screen bg-gray-700 text-white p-10">
//       <div className="text-center py-6 mb-10 animate-fade-in">
//         <h1 className="text-5xl font-extrabold tracking-wide">Government Schemes for MSMEs & Startups</h1>
//       </div>

//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//         {schemes.map((scheme, index) => (
//           <div
//             key={index}
//             className="bg-black text-white p-6 rounded-2xl shadow-lg hover:shadow-2xl transition transform hover:scale-105 flex flex-col items-center text-center animate-slide-up"
//           >
//             <img
//               src={scheme.image}
//               alt={scheme.title}
//               className="w-full h-40 object-cover rounded-lg shadow-md hover:rotate-2 transition-transform"
//             />
//             <h2 className="text-2xl font-bold mt-4 mb-2 text-yellow-600 hover:text-purple-600 transition-colors">
//               {scheme.title}
//             </h2>
//             <p className="text-yellow-300 mb-4 leading-relaxed">{scheme.description}</p>
//             <a
//               href={scheme.link}
//               target="_blank"
//               rel="noopener noreferrer"
//               className="bg-blue-600 text-white py-2 px-6 rounded-lg font-semibold hover:bg-purple-600 transition-transform hover:scale-105 shadow-md"
//             >
//               Learn More →
//             </a>
//           </div>
//         ))}
//       </div>
//     </div>
//     <Footer/>
//     </div>
//   );
// };

// export default SchemesPage;
